import { createModel } from '@rematch/core';
import { goalsService } from 'src/config/rootService';
import { RootModel } from 'src/config/rootStore';

import { GoalInterest } from '../models/goals';

export type GoalInterestsState = {
    oldGoalsAndInterests: GoalInterest[];
} | null; // null is used as a isFetching flag

const defaultState = null as GoalInterestsState;

export const goalInterests = createModel<RootModel>()({
    state: defaultState,
    reducers: {
        saveOldInterests: (state, payload: GoalInterest[] = []): GoalInterestsState => {
            return {
                ...state,
                oldGoalsAndInterests: payload,
            };
        },
        'authentication/onLogout': (): GoalInterestsState => {
            return defaultState;
        },
    },
    effects: dispatch => ({
        async fetchGoalInterests(): Promise<void> {
            const interests = await goalsService.fetchGoalInterests();

            if (interests) {
                dispatch.goalInterests.saveOldInterests(interests);
            }
        },
    }),
});
